<template>
  <div class="commission-details" ref="container">

    <div class="my-promotion">
      <div class="header"style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div>累计转账</div>
        </div>
        <div class="num">{{transfer_money || 0}}</div>
        <div class="name acea-row row-center-wrapper">
          <div>{{transfer_name}}余额</div>
        </div>
        <div class="num">{{commissionCount || 0}}</div>
      </div>
    </div>
    <div class="bill-details">
      <div class="nav acea-row">
        <div class="item"  @click="toCommissionList()" >
          转账
        </div>
        <div class="item on" >
          转账记录
        </div>
      </div>
    </div>


    <div class="sign-record sign-record1" ref="content">
      <div class="list" v-if="info.length > 0">
        <div class="item" v-for="(val, index) in info" :key="index">
          <!--<div class="data">{{ item.time }}</div>-->
          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                  <div class="name line1" >{{val.extract_field_name}}</div>
                <div class="name line1" >转入：{{ val.other_account }} {{val.other_nickname}}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num " style="color:#282828">
                {{ val.transfer_price }}
              </div>
              <div style="clear:both;"></div>

            </div>

          </div>
        </div>
      </div>

      <div class="shoppingCart" >
        <div
                style="margin-top:0px;"
                class="noCart"
                v-if="info.length === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>

    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .sign-record .list .item .listn .itemn .num {

    text-align: right;
  }
</style>
<script>
import { getTransfer,getTransferList } from "../../../api/user";
import Loading from "@components/Loading";

export default {
  name: "TransferRecord",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [

      ],
      transfer_money: 0,
      commissionCount: 0,
      post:{
        extract_field:'',
      },
      transfer_name:'',
      where: {
        page: 1,
        limit: 20
      },
      types: 4,
      loaded: false,
      loading: false
    };
  },
    watch: {
        $route(n) {
            if (n.name == "TransferRecord") {
              if(this.$route.params.types){
                this.post.extract_field = this.$route.params.types;
              }
                this.where.page = 1;
                this.loaded = false;
                this.loading = false;
                this.info = [];
                this.getTransfer();
                this.getIndex();
            }
        }
    },
  mounted: function() {
    if(this.$route.params.types){
      this.post.extract_field = this.$route.params.types;
    }
    this.getTransfer();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    toCommissionList(){
      this.$router.push({path:'/user/transfer/'+this.post.extract_field})
    },
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getTransferList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },

    getTransfer: function() {
      let that = this;
      getTransfer().then(
        res => {
          if(that.post.extract_field==''){
            that.post.extract_field = res.data.extract_field;
          }
          that.transfer_money = res.data.transfer_money;
          that.transfer_name = res.data.transferType[that.post.extract_field];
          that.commissionCount = res.data.user[that.post.extract_field];
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
